jQuery(document).ready(function( $ ) {

  // console.log('output');

  // $.ajax({P
  //   url: tct_js.ajaxurl,
  //   type: 'POST',
  //   data: {
  //     action: 'tct_ajax_example'
  //   },
  //   success: function(result) {
  //     $('body').append(result);
  //   }

  // });
  $('#nav-icon').on('click', function(){
    $('#nav-icon').toggleClass('open');
    $('#headerMenu').slideToggle('slow');
  });

  var $last = 0;

  $( window ).resize(function() {

    var $act = window.innerWidth;
    console.log($act);

    if ( $act > $last && $act > 768) {
      $('#nav-icon').removeClass('open');
      $('#headerMenu').removeAttr('style');
    }

    $last = $act;
  });

  $temp = $('.aktuelles a.page-numbers').attr('href') + '#news';
  $('.aktuelles a.page-numbers').attr('href', $temp);

});
